const oneTimePurchase = document.getElementById("one-time-purchase");
const weeklySubscription = document.getElementById("weekly-subscription");
const weeklySubs = document.querySelectorAll(".weekly-sbs");
const primaryButton = document.querySelector("[data-action='primary']");
const frequencySelect = document.getElementById("order-frequency");
const frequencySelector = document.querySelector(".frequency-selector");
frequencySelector.classList.remove("d-flex");
frequencySelector.classList.add("d-none");

const frequencyOptions = [
  {
    "type":"OneTimePurchase",
    "selling":null    
  },
  {
    "type":"WeeklySubscription",
    "selling":SELLING_PLAN_S    
  },
  {
    "type":"FortnightlySubscription",
    "selling":SELLING_PLAN_FS    
  }
];
const promotionalOffers = {
  // promo1: {
  //   mealRange: { min: 0, max: 10 },
  //   discounts: [0],
  //   notify: "FREE SHIPPING on all recurring deliveries",
  //   perServing:null
  // },
  promo2: {
    mealRange: { min: 0, max: 12 },
    discounts: [41.5,35.5,30,25,18], // 90
    notify: "Select 12 MEALS for $150 OFF & Free Shipping.",
    perServing:8.49
  },
  promo3: {
    mealRange: { min: 12, max: 14 },
    discounts: [51.24,35,30,30,20], // 120
    notify: "Select 14 MEALS for $166 OFF & Free Shipping",
    perServing:8.29
  },
  promo4: {
    mealRange: { min: 14, max: 18 },
    discounts: [71.25,39.25,30,30,29.5], // 120
    notify: "Select 18 MEALS for $200 OFF & Free Shipping",
    perServing:7.99
  },
};
const oneTimeOffers = {
  promo1: {
    mealRange: { min: 0, max: 8 },
    discounts: 3,
    notify: "Select 8 MEALS for 3% OFF",
    offerDiscount: "3PERCENTOFF",
  },
  promo2: {
    mealRange: { min: 8, max: 12 },
    discounts: 5, // 90
    notify: "Select 12 MEALS for 5% OFF",
    offerDiscount: "5PERCENTOFF",
  },
  promo3: {
    mealRange: { min: 12, max: 16 },
    discounts: 10, // 120
    notify: "Select 16 MEALS for 10% OFF",
    offerDiscount: "10PERCENTOFF",
  }
};

const oneTimeOffersSp = {  
  WELCOME25: {
    discounts: 25, // 120
    offerDiscount: "WELCOME25",
  }
};

const milestones = [
  {
    amount: 200,
    message: "10% Off achieved!",
    offerDiscount: "10PERCENTOFF",
    discounPercent: 10,
    offApplied: "10% OFF Applied",
  },
  {
    amount: 150,
    message: "Spend $200 for 10% OFF",
    offerDiscount: "5PERCENTOFF",
    discounPercent: 5,
    offApplied: "5% OFF Applied",
  },
  {
    amount: 100,
    message: "Spend $150 for 5% OFF",
    offerDiscount: "3PERCENTOFF",
    discounPercent: 3,
    offApplied: "3% OFF Applied",
  },
  {
    amount: 0,
    message: "Spend $100 for 3% OFF",
    offerDiscount: "",
    discounPercent: 0,
    offApplied: "",
  },
];

const userLoggedIn = ShopifyAnalytics.meta.page.customerId;
const subscriptionContractId = localStorage.getItem("contractInfo");

frequencySelect.addEventListener("change", async (event) => { 
  frequencySelect.disabled = true;
  const selectedValue = event.target.value;
  const frequencyType = frequencyOptions.find(option => option.type === selectedValue);

  try {
    // Fetch delivery info from localStorage
    const deliveryInfo = localStorage.getItem("deliveryInfo");
    // Create form data from LocalCart
    //console.log(frequencyType,deliveryInfo);
    const cart = localCart.getCartData();
    const attributes = cart.attributes;
    
    const deliveryAttributes = {
      DeliveryDate: attributes.deliveryDate || "",
      PackingDate: attributes.PackingDate || "",
      DeliveryStart: attributes.DeliveryStart || "",
      DeliveryEnd: attributes.DeliveryEnd || "",
      AddressType: attributes.AddressType || "",
      promotional: attributes.promotional || "",
      orderType: frequencyType
    };
    localStorage.setItem("cartAttributes", JSON.stringify(deliveryAttributes));
    const formData = localCart.createFormData(deliveryInfo, frequencyType);
    const state_data1 = window.state;

    if(!((state_data1.email != '') && (state_data1.date != '') && (state_data1.phone != '') && (state_data1.address != '') && (state_data1.freq != '') && (state_data1.suburb != '') && (state_data1.state != '') && (state_data1.postcode != ''))){
      localCart.updateCartInfoFromLocal('.cart-item-loop');
    }else{
      localCart.updateCartInfoFromLocal('.cart-item-loop', 1);
    }

    

  } catch (error) {
    console.error("Error during frequency change:", error);
  } finally {
    frequencySelect.disabled = false;
    //loader.classList.add("d-none");
  }
});